import React from 'react'

function OpenAccount() {
    return (  
        <div className='container pt-2 mb-2 border-top'>
            <div className='row text-center'>
            <h1 className='mt-5 mb-3'>
            Open a StocXpert account
            </h1>
            <h6>
            Online platform to invest in stocks, derivatives, mutual funds, ETFs, bonds, and more.
            </h6>
            <button className='p-2 btn btn-primary fs-4 mb-5 mt-5' style={{width:"18%", margin:"0 auto "}}>
                Sign up now
            </button>
            </div>
        </div>
    );
}

export default OpenAccount;